import $ from 'jquery';

import isObject from 'lodash/isObject';
import extend from 'lodash/extend';

import notificationSystemStore from 'zoomforth_zf/appglobals/notification-system.js';

import AlertModalView from './modals/alert_modern_modal.js';
import ConfirmModalView from './modals/confirm_modern_modal.js';

import { getXhrStatusCode, getDefaultErrorStringForXhr } from 'zoomforth_tools/error_messaging.js';

const makeError = function(message){
  var alert = document.createElement('div');
  alert.className = 'alert';
  alert.innerHTML = '<button type="button" class="close" data-dismiss="alert">&times;</button>';
  alert.appendChild(document.createTextNode(message));
  return alert;
};

const makeAlert= function(alertText, duration){
  var $alert = $(makeError(alertText));
  $alert.addClass('fixedAlert alert-warning');
  $('body .fixedAlert').remove();
  $('body').append($alert);
  if(typeof duration === 'undefined' || duration !== false){
    window.setTimeout(function(){
      $alert.fadeOut(500);
    },duration || 8000);
  }
};


const showDropdown = function($node){
  if($node.is(':visible')){
    return;
  }
  $node.show();
  window.setTimeout(function(){
    $(document).one('click', function(e){
      $node.hide();
    });
  }, 0);
};


    // Replaces the functionality of the 'window.alert' except that it
    // uses 'deferred' objects instead of interpreter blocking
// 
const alert = function(body, okText, options) {
  var opts;
  if (isObject(okText)) {
    opts = okText;
    okText = null;
  } else {
    opts = options || {};
  }
  return (new AlertModalView({
    body:body,
    okText:okText,
    title: (opts.title || null)
  })).show(opts); // Return the deferred
};


const confirm = function(text, okText, cancelText, options) {
  var opts;
  if (isObject(okText)) {
    opts = okText;
    okText = null;
  } else if (isObject(cancelText)) {
    opts = cancelText;
    cancelText = null;
  } else {
    opts = options || {};
  }
  var confirmViewInitData = extend({
    text:text,
    okText:okText,
    cancelText:cancelText
  }, opts);
  
  return (new ConfirmModalView(confirmViewInitData)).show(opts); // Return the deferred
};


const displayFixedErrorAlertForXhrFail = function(data){
    
  if ($ && $.fancybox){
    $.fancybox.hideLoading();
  }
  if(data.statusCode && data.statusCode().status != 0){ //show real errors, not aborted xhrs
    var $alert = $(makeError(getDefaultErrorStringForXhr(data)));
    $alert.addClass('fixedAlert alert-error');
    $('body .fixedAlert').remove();
    $('body').append($alert);
  } 
  
};


const displayNotificationForXhrFail = function(data) {

  if (getXhrStatusCode(data) != 0) {
    notificationSystemStore.get().addNotification({
      message: getDefaultErrorStringForXhr(data),
      level:'error'
    });
  }

};


const displayBestErrorAlertForXhrFail = function(data) {

  return displayNotificationForXhrFail(data);

};


export {
  displayFixedErrorAlertForXhrFail,
  displayNotificationForXhrFail,
  displayBestErrorAlertForXhrFail,
  showDropdown,
  makeAlert,
  confirm,
  alert
};

export default {
  displayFixedErrorAlertForXhrFail,
  displayNotificationForXhrFail,
  displayBestErrorAlertForXhrFail,
  showDropdown,
  makeAlert,
  confirm,
  alert
};
